import type { ReactNode } from "react";
import { X } from "lucide-react";
import { cn } from "@/lib/utils";

const COLORS: Record<string, string> = {
  zinc:    "bg-zinc-800 text-zinc-300 ring-zinc-700",
  indigo:  "bg-rose-500/15 text-rose-300 ring-rose-500/30",
  blue:    "bg-sky-500/15 text-sky-300 ring-sky-500/30",
  cyan:    "bg-cyan-500/15 text-cyan-300 ring-cyan-500/30",
  emerald: "bg-emerald-500/15 text-emerald-300 ring-emerald-500/30",
  green:   "bg-green-500/15 text-green-300 ring-green-500/30",
  amber:   "bg-amber-500/15 text-amber-300 ring-amber-500/30",
  yellow:  "bg-yellow-500/15 text-yellow-300 ring-yellow-500/30",
  orange:  "bg-orange-500/15 text-orange-300 ring-orange-500/30",
  rose:    "bg-rose-500/15 text-rose-300 ring-rose-500/30",
  red:     "bg-red-500/15 text-red-300 ring-red-500/30",
  pink:    "bg-pink-500/15 text-pink-300 ring-pink-500/30",
  violet:  "bg-rose-500/15 text-rose-300 ring-rose-500/30",
  purple:  "bg-purple-500/15 text-purple-300 ring-purple-500/30",
  fuchsia: "bg-fuchsia-500/15 text-fuchsia-300 ring-fuchsia-500/30",
};

export const BADGE_COLORS = Object.keys(COLORS);

export function Badge({
  children,
  color = "zinc",
  size = "sm",
  onRemove,
  className,
}: {
  children: ReactNode;
  color?: string;
  size?: "xs" | "sm" | "md";
  onRemove?: () => void;
  className?: string;
}) {
  const sizeClass = {
    xs: "h-5 px-1.5 text-[10px] gap-0.5",
    sm: "h-6 px-2 text-xs gap-1",
    md: "h-7 px-2.5 text-sm gap-1.5",
  }[size];
  return (
    <span
      className={cn(
        "inline-flex items-center whitespace-nowrap rounded-md font-medium ring-1 ring-inset",
        COLORS[color] ?? COLORS.zinc,
        sizeClass,
        className
      )}
    >
      {children}
      {onRemove && (
        <button
          type="button"
          onClick={(e) => { e.stopPropagation(); onRemove(); }}
          className="ml-0.5 -mr-0.5 inline-flex h-4 w-4 items-center justify-center rounded hover:bg-black/20"
          aria-label="Remove"
        >
          <X className="h-3 w-3" />
        </button>
      )}
    </span>
  );
}
